import { createSelector } from 'reselect';
import { get, map, compose, every, filter, flatMap, groupBy } from 'lodash/fp';

import decodeChallengeEntrySelection from '../normalizers/decodeChallengeEntrySelection';
import { getChallengeGroupName } from '../utils/challengeUtils';
import routeFilterSelector from './routeFilterSelector';

export const mapLineups = map(lineup => {
  return {
    entryCount: lineup.entryCount,
    entryIds: Array.isArray(lineup.challenges)
      ? map('id', flatMap('userEntries', lineup.challenges))
      : [],
    challenges: lineup.challenges,
    firstChallenge: get('challenges[0]', lineup) || {},
    id: lineup.id,
    isRacing: lineup.isRacing,
    favorite: lineup.favorite,
    name:
      Array.isArray(lineup.challenges) && lineup.challenges.length
        ? getChallengeGroupName(lineup.challenges)
        : get('slate.name', lineup),
    rank: get('userEntry.position', lineup),
    totalEntries: get('userEntry.entry_count', lineup),
    score: lineup.score,
    selection: decodeChallengeEntrySelection(lineup.selection),
    selectionHash: lineup.selectionHash,
    slateId: get('slate.id', lineup),
    slateName: get('slate.name', lineup),
    sportId: lineup.sportId,
    competitionId: lineup.slate.competition_type_id,
    sportIcon: lineup.sportIcon,
    startTime: new Date(lineup.slate.start_time).getTime(),
    status: lineup.status,
    statusId: lineup.slate.status.id,
    statusLabel: lineup.slate.status.name,
    remainingSalary: lineup.remainingSalary,
    totalPrize: lineup.totalPrize
  };
});

function getMyTeams(lineups, lineupChallenges, lineupTypeFilters, selectionHash, filterSports) {
  const lineupsWithChallenges = selectionHash
    ? lineups.map(lineup =>
        lineup.selectionHash === selectionHash
          ? { ...lineup, challenges: lineupChallenges }
          : lineup
      )
    : lineups;

  return compose(
    groupBy('status'),
    filter(lineup => every(x => lineup[x], lineupTypeFilters)),
    filterSports,
    mapLineups
  )(lineupsWithChallenges);
}

const myTeamsSelector = createSelector(
  get('myTeams.lineups'),
  get('myTeams.lineupChallenges'),
  get('myTeams.lineupTypeFilters'),
  (state, selectionHash) => selectionHash,
  routeFilterSelector,
  getMyTeams
);

export default myTeamsSelector;
